// Pembantu format & paparan
export function formatRM(value) {
  const n = Number(value || 0);
  // nbsp antara RM dan angka: elak "RM" terpisah ke baris sendiri di skrin kecil
  return 'RM ' + n.toLocaleString('en-MY', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

// Format ringkas untuk paksi carta: 1500 -> "1.5k", 2500000 -> "2.5M"
export function formatCompact(value) {
  const n = Number(value || 0);
  if (Math.abs(n) >= 1_000_000) return (n / 1_000_000).toLocaleString('en-MY', { maximumFractionDigits: 1 }) + 'M';
  if (Math.abs(n) >= 1_000) return (n / 1_000).toLocaleString('en-MY', { maximumFractionDigits: 1 }) + 'k';
  return String(Math.round(n));
}

export function initials(nama = '') {
  const parts = nama.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export const AVATAR_PALETTES = [
  'bg-blue-100 text-blue-900 border-blue-200 dark:bg-blue-950/80 dark:text-blue-300 dark:border-blue-800/60',
  'bg-emerald-100 text-emerald-900 border-emerald-200 dark:bg-emerald-950/80 dark:text-emerald-300 dark:border-emerald-800/60',
  'bg-amber-100 text-amber-900 border-amber-200 dark:bg-amber-950/80 dark:text-amber-300 dark:border-amber-800/60',
  'bg-pink-100 text-pink-900 border-pink-200 dark:bg-pink-950/80 dark:text-pink-300 dark:border-pink-800/60',
  'bg-purple-100 text-purple-900 border-purple-200 dark:bg-purple-950/80 dark:text-purple-300 dark:border-purple-800/60',
  'bg-sky-100 text-sky-900 border-sky-200 dark:bg-sky-950/80 dark:text-sky-300 dark:border-sky-800/60',
  'bg-rose-100 text-rose-900 border-rose-200 dark:bg-rose-950/80 dark:text-rose-300 dark:border-rose-800/60',
  'bg-teal-100 text-teal-900 border-teal-200 dark:bg-teal-950/80 dark:text-teal-300 dark:border-teal-800/60',
];

export function avatarClass(seed = '') {
  let h = 0;
  for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) % 997;
  return AVATAR_PALETTES[h % AVATAR_PALETTES.length];
}

const AVATAR_COLORS = [
  { bg: '#EFF6FF', fg: '#1E3A8A' },
  { bg: '#ECFDF5', fg: '#047857' },
  { bg: '#FEF3C7', fg: '#B45309' },
  { bg: '#FCE7F3', fg: '#BE185D' },
  { bg: '#EDE9FE', fg: '#6D28D9' },
  { bg: '#E0F2FE', fg: '#0369A1' },
  { bg: '#FEE2E2', fg: '#B91C1C' },
  { bg: '#F0FDFA', fg: '#0F766E' },
];

export function avatarColor(seed = '') {
  let h = 0;
  for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) % 997;
  return AVATAR_COLORS[h % AVATAR_COLORS.length];
}

export const STATUS_META = {
  belum: { labelKey: 'stBelum', dot: '#DC2626', bg: '#FEF2F2', fg: '#B91C1C', border: '#FCA5A5' },
  separa: { labelKey: 'stSepara', dot: '#D97706', bg: '#FFFBEB', fg: '#B45309', border: '#FCD34D' },
  lunas: { labelKey: 'stLunas', dot: '#10B981', bg: '#ECFDF5', fg: '#047857', border: '#6EE7B7' },
  pending: { labelKey: 'stPending', dot: '#D97706', bg: '#FFFBEB', fg: '#B45309', border: '#FCD34D' },
  lulus: { labelKey: 'stLulus', dot: '#10B981', bg: '#ECFDF5', fg: '#047857', border: '#6EE7B7' },
  tolak: { labelKey: 'stTolak', dot: '#DC2626', bg: '#FEF2F2', fg: '#B91C1C', border: '#FCA5A5' },
};
